<script setup>
import { computed } from 'vue'
import DOMPurify from 'dompurify'

const props = defineProps({ popup: { type: Object, required: true } })
const emit = defineEmits(['close'])
const safeTitle = computed(() => DOMPurify.sanitize(props.popup.title || '', { USE_PROFILES: { html: true }, FORBID_TAGS: ['form', 'input', 'button', 'iframe', 'style'], FORBID_ATTR: ['style'] }))
const safeContent = computed(() => DOMPurify.sanitize(props.popup.content || '', { USE_PROFILES: { html: true }, FORBID_TAGS: ['form', 'input', 'button', 'iframe', 'style'], FORBID_ATTR: ['style'] }))
</script>

<template>
  <div class="modal-backdrop public-popup-backdrop">
    <section class="public-popup" role="dialog" aria-modal="true" aria-labelledby="public-popup-title">
      <button class="modal-close" type="button" aria-label="关闭提示" @click="emit('close')">×</button>
      <h2 v-if="popup.kind === 'security'" id="public-popup-title">安全提示</h2>
      <div v-else id="public-popup-title" class="public-popup-title" v-html="safeTitle" />
      <p v-if="popup.kind === 'security'" class="public-popup-text">{{ popup.content }}</p>
      <div v-else class="public-popup-content" v-html="safeContent" />
      <button class="primary" type="button" @click="emit('close')">{{ popup.button }}</button>
    </section>
  </div>
</template>

<style scoped>
.public-popup-backdrop { z-index: 10000; }
.public-popup { position: relative; width: min(520px, calc(100vw - 32px)); padding: 32px; border-radius: 16px; background: white; color: #203448; }
.public-popup-title { margin-bottom: 20px; font-size: 22px; font-weight: 600; }
.public-popup-text { white-space: pre-wrap; overflow-wrap: anywhere; }
.public-popup-content { max-height: 55vh; overflow: auto; overflow-wrap: anywhere; }
.public-popup-content :deep(img) { max-width: 100%; height: auto; }
.public-popup > button.primary { display: block; width: 100%; margin-top: 24px; }
</style>
